<app-loader></app-loader>

<section class="login-page">
  <div class="container login-container">
    <div class="login-shell">
      <div class="row g-0 align-items-stretch">

        <!-- Bloque visual / presentación -->
        <div class="col-lg-6 login-hero">
          <div class="hero-content">
            <a class="brand" [href]="global.urlServer" aria-label="Ir al inicio de iGuau">
              <span class="brand-icon">
                <i class="fa-solid fa-paw"></i>
              </span>
              <span>iGuau</span>
            </a>

            <div class="pet-visual" aria-hidden="true">
              <div class="pet-image pet-image-main">
                <img [src]="backgroundImage" alt="">
              </div>
              <div class="pet-image pet-image-secondary">
                <img [src]="global.urlServer + 'img/hombre-register.png'" alt="">
              </div>
              <span class="visual-decoration decoration-paw">
                <i class="fa-solid fa-paw"></i>
              </span>
              <span class="visual-decoration decoration-heart">
                <i class="fa-solid fa-heart"></i>
              </span>
            </div>

            <div class="hero-copy">
              <span class="eyebrow">Comunidad iGuau</span>
              <h1>Donde las mascotas hacen amigos</h1>
              <p>
                Vuelve a conectar con una comunidad creada para mascotas y las personas que las quieren.
                Descubre nuevos perfiles, encuentra compañeros de paseo y comparte momentos especiales.
              </p>
            </div>

            <div class="hero-benefits">
              <div class="benefit-item">
                <span><i class="fa-solid fa-paw"></i></span>
                <div>
                  <strong>Conoce nuevas mascotas</strong>
                  <small>Encuentra perfiles afines cerca de ti.</small>
                </div>
              </div>
              <div class="benefit-item">
                <span><i class="fa-solid fa-comments"></i></span>
                <div>
                  <strong>Conecta y comparte</strong>
                  <small>Habla, organiza paseos y crea nuevas amistades.</small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Acceso -->
        <div class="col-lg-6 login-panel">
          <div class="login-card">
            <ng-container *ngIf="!remember; else rememberTemplate">
              <div class="login-heading">
                <span class="login-heading-icon"><i class="fa-solid fa-paw"></i></span>
                <div>
                  <span class="login-kicker">¡Qué bueno verte de nuevo!</span>
                  <h2>Inicia sesión</h2>
                  <p>Accede a tu cuenta para continuar en iGuau.</p>
                </div>
              </div>

              <form [formGroup]="form" (ngSubmit)="acceso()" novalidate>
                <div class="mb-3">
                  <label for="username" class="form-label">Correo electrónico</label>
                  <div class="input-wrap" [class.is-invalid]="form.get('username')?.invalid && form.get('username')?.touched">
                    <i class="fa-solid fa-envelope input-icon"></i>
                    <input
                      id="username"
                      type="email"
                      class="form-control"
                      placeholder="nombre@ejemplo.com"
                      formControlName="username"
                      autocomplete="email"
                      maxlength="320"
                      [readonly]="busy"
                      (input)="error=''">
                  </div>
                  <div class="field-error" *ngIf="form.get('username')?.touched && form.get('username')?.hasError('required')">
                    Introduce tu correo electrónico.
                  </div>
                  <div class="field-error" *ngIf="form.get('username')?.touched && form.get('username')?.hasError('email')">
                    Introduce un correo electrónico válido.
                  </div>
                </div>

                <div class="mb-2">
                  <div class="d-flex align-items-center justify-content-between gap-3">
                    <label for="password" class="form-label mb-0">Contraseña</label>
                    <button class="forgot-link" type="button" *ngIf="!busy" (click)="rememberPassword()">
                      ¿La has olvidado?
                    </button>
                  </div>

                  <div class="input-wrap mt-2" [class.is-invalid]="form.get('password')?.invalid && form.get('password')?.touched">
                    <i class="fa-solid fa-lock input-icon"></i>
                    <input
                      id="password"
                      [type]="showPassword ? 'text' : 'password'"
                      class="form-control password-input"
                      placeholder="Introduce tu contraseña"
                      formControlName="password"
                      autocomplete="current-password"
                      maxlength="200"
                      [readonly]="busy"
                      (input)="error=''">
                    <button
                      type="button"
                      class="password-toggle"
                      (click)="togglePassword()"
                      [attr.aria-label]="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
                      [attr.aria-pressed]="showPassword">
                      <i class="fa-solid" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                    </button>
                  </div>
                  <div class="field-error" *ngIf="form.get('password')?.touched && form.get('password')?.hasError('required')">
                    Introduce tu contraseña.
                  </div>
                </div>

                <div class="login-error" role="alert" *ngIf="error">
                  <i class="fa-solid fa-circle-exclamation"></i>
                  <span [innerHTML]="error"></span>
                </div>

                <button class="btn btn-primary login-submit" type="submit" [disabled]="busy">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="busy"></span>
                  <span>{{ busy ? 'Accediendo...' : 'Acceder a iGuau' }}</span>
                  <i class="fa-solid fa-arrow-right" *ngIf="!busy"></i>
                </button>

                <div class="login-divider">
                  <span>o continúa con</span>
                </div>

                <div class="social-login">
                  <div id="google-btn" class="google-button"></div>
                </div>

                <div class="register-box" *ngIf="!busy">
                  <span>¿Aún no tienes cuenta?</span>
                  <a [href]="global.urlServer + 'register'">Crear cuenta gratis</a>
                </div>

                <div class="login-privacy">
                  <i class="fa-solid fa-shield-halved"></i>
                  <span>Tus datos de acceso se gestionan de forma segura.</span>
                </div>
              </form>
            </ng-container>

            <ng-template #rememberTemplate>
              <div class="remember-wrapper">
                <button type="button" class="back-login" (click)="remember = false">
                  <i class="fa-solid fa-arrow-left"></i>
                  Volver al acceso
                </button>
                <app-remember></app-remember>
              </div>
            </ng-template>
          </div>
        </div>

      </div>
    </div>
  </div>
</section>
